// extracted by mini-css-extract-plugin
export default {"container":"PortalCheckbox__container__Y_xzh"};